import {
  useGetCustomerConfigQuery,
  useUpdateCustomerConfigMutation,
} from "@/redux/reducer/customers.api";
import { getUserTenantId } from "@talentech/bff-login";
import {
  Box,
  Forms,
  Grid,
  PageTitle,
  Row,
  Switch,
  TalentechFormFieldTypes,
  Typography,
} from "@talentech/components";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const PrivacySettings = () => {
  const tenantId = useSelector(getUserTenantId);
  const { data: customerConfig } = useGetCustomerConfigQuery({ tenantId });
  const [updateCustomerConfig] = useUpdateCustomerConfigMutation();
  const privacySettings = customerConfig?.settings.privacy;

  if (!privacySettings) return null;

  const onUpdateOntame = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updateOntameConfig = updateCustomerConfig({
      tenantId,
      settings: {
        privacy: {
          ...privacySettings,
          analytics: {
            ontame: event.target.checked,
          },
        },
      },
    });

    toast.promise(updateOntameConfig.unwrap(), {
      pending: "Updating Ontame Analytics...",
      success: "Ontame Analytics updated successfully",
      error: "Failed to update Ontame Analytics",
    });
  };

  const onUpdateCookiebot = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updateCookiebotConfig = updateCustomerConfig({
      tenantId,
      settings: {
        privacy: {
          ...privacySettings,
          cookies: {
            cookiebot: {
              cid: privacySettings?.cookies.cookiebot.cid,
              enable: event.target.checked,
            },
          },
        },
      },
    });

    toast.promise(updateCookiebotConfig.unwrap(), {
      pending: "Updating Cookiebot...",
      success: "Cookiebot updated successfully",
      error: "Failed to update Cookiebot",
    });
  };

  const onUpdateCookiebotCID = (values: { form: { cid: string } }) => {
    const updateCookiebotConfig = updateCustomerConfig({
      tenantId,
      settings: {
        privacy: {
          ...privacySettings,
          cookies: {
            cookiebot: {
              ...privacySettings?.cookies.cookiebot,
              cid: values.form.cid,
            },
          },
        },
      },
    });

    toast.promise(updateCookiebotConfig.unwrap(), {
      pending: "Updating Cookiebot CID...",
      success: "Cookiebot CID updated successfully",
      error: "Failed to update Cookiebot CID",
    });
  };

  const formProps = {
    handleSubmit: onUpdateCookiebotCID,
    submitLabel: "Update",
    handleReset: () => {},
    formFields: {
      section: "",
      id: "form",
      fields: [
        {
          field: "cid",
          label: "Cookiebot CID",
          type: TalentechFormFieldTypes.TEXT,
          initialValue: privacySettings?.cookies.cookiebot.cid,
          options: {
            readOnly: !privacySettings?.cookies.cookiebot.enable,
          },
        },
      ],
    },
  };
  return (
    <>
      <PageTitle title="Privacy Settings" />
      <Grid container spacing={3} className="mt-4">
        <Row>
          <Grid xs={12} md={6}>
            <Box paper rounded spacing={4}>
              <Typography variant="h2">Analytics</Typography>
              <Typography variant="p">
                Ontame Analytics is a tool that helps you track your career site
                traffic and behavior.
              </Typography>
              <Switch
                checked={privacySettings?.analytics.ontame}
                onChange={onUpdateOntame}
                label="Enable Ontame Analytics"
                id="ontame-analytics"
              />
            </Box>
          </Grid>
          <Grid xs={12} md={6}>
            <Box paper rounded spacing={4}>
              <Typography variant="h2">Cookies</Typography>
              <Typography variant="p">
                Cookiebot is a tool that helps you manage your cookies and
                privacy settings.
              </Typography>
              <Switch
                checked={privacySettings?.cookies.cookiebot.enable}
                onChange={onUpdateCookiebot}
                label="Enable Cookiebot"
                id="cookiebot"
              />

              <div className="mt-4">
                <Forms.Form {...formProps} />
              </div>
            </Box>
          </Grid>
        </Row>
      </Grid>
    </>
  );
};

export default PrivacySettings;
